import type { Components, Theme } from "@mui/material";
import { getPaletteColor } from "./util";

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    cyan: true;
    green: true;
    yellow: true;
    orange: true;
    magenta: true;
    purple: true;
    dark: true;
  }
}

const buttonSizeStyle = {
  small: {
    height: "36px",
    padding: "0 16px",
    lineHeight: "24px",
  },
  medium: {
    height: "48px",
    padding: "0 24px",
    lineHeight: "24px",
  },
  large: {
    height: "56px",
    padding: "0 32px",
    lineHeight: "24px",
  },
};

export const covestroMuiButtonBase: Components<Theme>["MuiButtonBase"] = {
  styleOverrides: {
    root: {
      "&:hover": {
        transitionDuration: 0.25,
      },
    },
  },
};
export const covestroMuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    disableElevation: true,
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      textTransform: "none",
      letterSpacing: 0.4,
      fontWeight: 500,
      ...buttonSizeStyle[ownerState.size ?? "medium"],
    }),
    contained: ({ ownerState, theme }) => ({
      "&:hover": {
        background: getPaletteColor(theme, ownerState.color)?.light,
      },
    }),
    text: ({ ownerState, theme }) => ({
      padding: theme.spacing(1),
      "&:hover": {
        background: "transparent",
        color: getPaletteColor(theme, ownerState.color)?.light,
      },
    }),
    outlined: ({ ownerState, theme }) => ({
      borderColor: getPaletteColor(theme, ownerState.color)?.main,
      color: getPaletteColor(theme, ownerState.color)?.main,
      background: "transparent",
      borderWidth: "2px",
      "&:hover": {
        background: "transparent",
        borderWidth: "2px",
        borderColor: getPaletteColor(theme, ownerState.color)?.light,
        color: getPaletteColor(theme, ownerState.color)?.light,
      },
    }),
  },
};

export const covestroMuiButtonGroup: Components<Theme>["MuiButtonGroup"] = {
  defaultProps: {
    disableElevation: true,
    disableRipple: true,
  },
};
